import { OrdersService, FetchingError } from '@/services/orders.service'
import Vue from 'vue'
import router from '@/router/index'

const state = {
    version: 1.2,
    currentStep: 1,
    fetching: true,
    savingOrder: false,
    savingOrderSuccess: false,
    fetchingLaborsForces: false,
    fetchingLaborsForcesComplete: false,
    fetchingVerification: false,
    fetchingVerificationSuccess: false,
    fetchingVerificationError: '',
    sendingCode: false,
    codeSent: false,
    codeSentText: '',
    fetchingError: '',
    fetchingErrorCode: 0,
    categories: [],
    location: {
        street: '',
        zip: '',
        city: '',
        zipCity: '',
        country: 1,
        // country_name: 'Deutschland'
    },
    invoiceAddress: {
        street: '',
        zip: '',
        city: '',
        country: 1,
        same_as_jobs_address: true
    },
    baseData: {
        showCategoryTitle: false,
        country: 1,
        category: 0,
        client: false,
        clients_name: '',
        clients_contacts_firstname: '',
        clients_contacts_lastname: '',
        clients_contacts_mail: '',
        clients_contacts_mobile: '',
        flexible_date_contacts_mail: '',
        flexible_date_contacts_mobile: '',
        clients_contacts_hash: false,
        clients_type: 'private',
        flexibleDateHints: [
            {
                hint_manager: ''
            }
        ],
        additional_info: '',
        // max_distance: 5,
        max_distance: 75,
        photographers_min_rating: 7,
        freetext: '',
        freetext_label: '',

        clients_show_freetext: false,
        order_name: '',
        first_offer: false,
    },
    paymentMethods: [
        {
            name: 'Paypal',
            enabled: false,
            selected: false
        },
        {
            name: 'Auf Rechnung',
            enabled: false,
            selected: true,
        }
    ],
    selected_category: '',
    category: {},
    articles: [],
    subCategories: [],
    current_articles: [],
    date: {
        is_flexible: true,
        flexible_date: 2,
        starting_date: '',
        starting_time: '',
        starting_date_human: '',
        info: '',
        ending_date: '',
        ending_date_human: '',
        ending_time: ''
    },
    totals: {
        brutto: 0,
        netto: 0,
        vat_sum: 0,
        vat: {
            0: { sum: 0 },
            7: { sum: 0 },
            19: { sum: 0 }
        }
    },
    totalTravelCost: 0,
    hideNavigation: false,
    job: {
        jobs_hash: '',
        pdf_url: ''
    },
    verificationCode: '',
    footerExpanded: false,
    randomCategoryThumbnail: false,
    userExists: false,
    password: '',
    auth: {
        authenticating: false,
        authenticated: false,
        authenticatingError: false,
        newUser: true
    },
    pwResetting: false,
    pwResetted: false,
    pwResettedText: ''
}

const getters = {
    version: (state) => {
        return state.version;
    },
    pwResetted: (state) => {
        return state.pwResetted;
    },
    pwResettedText: (state) => {
        return state.pwResettedText;
    },
    pwResetting: (state) => {
        return state.pwResetting;
    },
    password: () => {
        return ''
    },
    userExists: (state) => {
        return state.userExists;
    },
    footerExpanded: (state) => {
        return state.footerExpanded;
    },
    sendingCode: (state) => {
        return state.sendingCode;
    },
    codeSent: (state) => {
        return state.codeSent;
    },
    codeSentText: (state) => {
        return state.codeSentText;
    },
    fetchingVerification: (state) => {
        return state.fetchingVerification;
    },
    fetchingVerificationSuccess: (state) => {
        return state.fetchingVerificationSuccess;
    },
    fetchingVerificationError: (state) => {
        return state.fetchingVerificationError;
    },
    verificationCode: (state) => {
        return state.verificationCode;
    },
    hideNavigation: (state) => {
        return state.hideNavigation;
    },
    job: (state) => {
        return state.job;
    },
    jobs_hash: (state) => {
        return state.job.jobs_hash
    },
    pdf_url: (state) => {
        return state.job.pdf_url
    },
    totals: (state) => {
        return state.totals;
    },
    totalTravelCost: (state) => {
        return state.totalTravelCost;
    },
    invoiceAddress: (state) => {
        return state.invoiceAddress;
    },
    paymentMethods: (state) => {
        return state.paymentMethods.filter(p => p.enabled == true)
    },
    // selected_payment_method: (state) => {
    //     return state.paymentMethods.filter(p => p.selected == true)
    // },
    currentStep: (state) => {
        return state.currentStep;
    },
    categories: (state) => {
        return Object.entries(state.categories).map((category) => {
            const data = category[1];
            return {
                name: data.jobs_tasks_categories_name,
                value: data.id,
                thumbnail_url: data.jobs_tasks_categories_thumbnail_url
            }
        });
    },
    randomCategoryThumbnail: (state) => {
        if (!state.categories.length == 0) {
            return false;
        }

        const thumbnails = Object.entries(state.categories).map(c => {
            return c[1].jobs_tasks_categories_thumbnail_url;
        })
        const index = Math.floor(Math.random() * thumbnails.length)
        return thumbnails[index];
    },
    selected_category: (state) => {
        return state.selected_category
    },
    current_articles: (state) => {
        const subCategories = state.subCategories;
        return state.current_articles.map(article => {
            const { category_id } = article;
            const category = subCategories.filter(cat => cat.id == category_id);
            if (category.length != 0) {
                article.articles_category_name = category[0].jobs_tasks_categories_name;
                article.thumbnail = category[0].jobs_tasks_categories_thumbnail_url;
            }
            return article;
        });
    },
    category: (state) => {
        const data = Object.entries(state.categories);
        const selected_category = data.filter(cat => cat[1].id == state.selected_category);
        const arr = selected_category.map(data => {
            const category = data[1];
            return {
                id: category.id,
                name: category.jobs_tasks_categories_name
            }
        });
        return arr[0];
    },
    debug_mode: (state) => {
        return state.debug_mode;
    },
    fetchingErrorCode: (state) => {
        return state.fetchingErrorCode
    },

    fetchingError: (state) => {
        return state.fetchingError
    },

    fetching: (state) => {
        return state.fetching
    },

    categoryTitle: (state) => {
        return state.categoryTitle
    },

    categoryIsCollection: (state) => {
        return state.categoryIsCollection
    },

    baseData: (state) => {
        return state.baseData
    },
    countries: (state) => {
        return state.countries;
    },
    laborForces: (state) => {
        return state.laborForces;
    },
    location: (state) => {
        return state.location;
    },
    auth: (state) => {
        return state.auth;
    },
    date: (state) => {
        return state.date;
    },
    articles: (state) => {
        return state.articles;
    },
    static_articles: (state) => {
        return state.static_articles;
    },
    customizable_articles: (state) => {
        return state.customizable_articles;
    },
    hideSummary: (state) => {
        return state.hideSummary;
    },
    selected_user: (state) => {
        return state.selected_user;
    },
    coords: (state) => {
        return state.coords;
    },
    savingOrder: (state) => {
        return state.savingOrder;
    },
    savingOrderSuccess: (state) => {
        return state.savingOrderSuccess;
    },
    subCategories: (state) => {
        return state.subCategories;
    }
}

const actions = {
    getCurrentVersion() {
        return state.version;
    },
    async resetPassword( { commit, getters }) {
        commit('resetPwRequest');
        try {
            const options = {
                clients_contacts_mail: getters.baseData.clients_contacts_mail
            }
            const data = await OrdersService.resetPassword(options);
            commit('resetPwSuccessfull', data)
            return true;
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }
            return false
        }
    },

    async signIn( { commit, getters }, payload) {
        commit ('signInRequest');
        try {
            const options = {
                pw: payload,
                clients_contacts_mail: getters.baseData.clients_contacts_mail
            }
            const client = await OrdersService.signIn(options);
            if (client) {
                commit('signInSuccessfull')
                commit('getOrCreateClientSuccess', client);
                this.dispatch('orders/fetchInvoiceAddress', client.clients_addresses_hash);
                return true;
            } else {
                commit('signInFailed')
                return false;
            }
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }
            return false
        }
    },
    async fetchInvoiceAddress( { commit }, clients_addresses_hash) {
        try {
            const options = {
                clients_addresses_hash: clients_addresses_hash
            }
            const address = await OrdersService.fetchInvoiceAddress(options);
            if (address) {
                address.same_as_jobs_address = 0;
                console.log(address);
                commit('updateInvoiceAddress', address);
                return true;
            } else {
                commit('updateInvoiceAddress', { same_as_jobs_address: 1});
            }
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }
            return false
        }
    },
    async checkIfUserExists( { commit, getters }) {
        commit ('fetchingRequest');
        try {
            const options = {
                clients_contacts_mail: getters.baseData.clients_contacts_mail
            }
            const userExists = await OrdersService.userExists(options);
            if (userExists) {
                commit('fetchingUserExistsSuccessFull')
                return true;
            } else {
                commit('fetchingUserExistsError')
                return false;
            }
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }
            return false
        }
    },
    async checkVerifyCode( { commit, getters } ) {
        commit('fetchingVerificationRequest')
        try {
            const options = {
                code: getters.verificationCode,
                jobs_hash: getters.job.jobs_hash
            }
            const codeok = await OrdersService.checkVerifyCode(options);
            if (codeok) {
                commit('fetchingVerificationSuccess');
            } else {
                commit('fetchingVerificationError');
            }
            return codeok;
        } catch (e) {
            if (e instanceof FetchingError) {
                console.log('fetching error:', e)
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }
            return false
        }
    },
    async resetCode( { commit, getters } ) {
        commit('sendingCode')
        try {
            const options = {
                jobs_hash: getters.job.jobs_hash
            }
            const res = await OrdersService.resetCode(options);
            commit('codeSent', res)
        } catch (e) {
            if (e instanceof FetchingError) {
                console.log('fetching error:', e)
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }
            return false
        }
    },

    async setBaseData({ commit }) {
        commit('fetchingRequest');
        const appWrapper = document.querySelectorAll('#app-wrapper');
        try {
            if (appWrapper.length != 1) {
                throw new FetchingError(500, 'App Wrapper nicht gefunden');
            }
            const { country, category, client, freetext, clientsContactsHash, showCategoryTitle } = appWrapper[0].dataset;
            const categories = await OrdersService.fetchCategories();
            await this.dispatch('orders/fetchFlexibleDateHints');
            commit('fetchingCategoriesSuccess', categories);
            commit('setCurrentDatetime');
            if (category) {
                commit("updateCategoriesSelection", {
                    categories_id: category
                });
            }
        } catch (e) {
            if (e instanceof FetchingError) {
                console.log('fetching error:', e)
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }
            return false
        }
    },
    async resetNavigation( { commit } ) {
        commit('updateCurrentStep', 1);
        router.push('/');
    },
    async determineLocation( { commit }, payload) {
        if (payload.fetching) {
            commit('fetchingRequest');
        }
        try {
            const data = await OrdersService.determineLocation(
                {
                    zipCity: payload.zipCity
                }
            );
            commit('updateLocation', data);
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }
            return false;
        }
    },
    async generatePdf( { commit, getters}) {
        commit('generatePdfRequest');
        try {
            const data = await OrdersService.generatePdf({
                jobs_hash: getters.job.jobs_hash
            });
            commit('generatePdfSuccess', data);
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('generatePdfError', { errorCode: e.errorCode, errorMessage: e.message })
            }
            return false;
        }
    },
    async updateCategoriesSelection( { commit }, payload ) {
        commit('updateCategoriesSelection', payload);
    },
    async navigate( { commit }, payload) {
        commit('updateCurrentStep', payload);
    },
    async toggleArticlesVisibilty( { commit }, payload) {
        commit('toggleArticlesVisibilty', payload);
    },
    async subcategoryReadmore( { commit }, payload) {
        commit('subcategoryReadmore', payload);
    },
    async saveOrCreateClient( { commit, getters }, payload) {
        commit('getOrCreateClientRequest');
        try {
            const storeData = {
                clients_contacts_mail: getters.baseData.clients_contacts_mail,
                clients_name: getters.baseData.clients_name,
                clients_contacts_firstname: getters.baseData.clients_contacts_firstname,
                clients_contacts_lastname: getters.baseData.clients_contacts_lastname,
                clients_contacts_mobile: getters.baseData.clients_contacts_mobile,
                clients_type: getters.baseData.clients_type,
                address: getters.invoiceAddress.same_as_jobs_address ? getters.location : getters.invoiceAddress
            }

            if (payload.clients_contacts_hash) {
                storeData.clients_contacts_hash = payload.clients_contacts_hash;
            }
            if (payload.clients_hash) {
                storeData.clients_hash = payload.clients_hash;
            }
            const client = await OrdersService.getOrCreateClient(storeData);
            commit('getOrCreateClientSuccess', client);
            commit('signInSuccessfull', { newUser: true })
            this.dispatch('orders/fetchInvoiceAddress', client.clients_addresses_hash);
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('getOrCreateClientError', { errorCode: e.errorCode, errorMessage: e.message })
            }

            return false;
        }
    },
    async saveOrder({ commit, getters }, payload) {
            // 2. take that clients hash and put it into the order data
            try {
                commit('saveOrderRequest')
                console.log(getters.current_articles, getters.articles);
                const storeData = {
                    clients_hash: getters.baseData.clients_hash,
                    clients_contacts_hash: getters.baseData.clients_contacts_hash,
                    clients_addresses_hash: getters.baseData.clients_addresses_hash,
                    jobs_tasks_country: getters.location.country,
                    // jobs_tasks_categories: getters.selected_categories,
                    // customInputs, // ???
                    // flexible_date_stuff, // !!
                    jobs_tasks_flexible_date: getters.date.is_flexible,
                    flexible_date_hint_selection: getters.date.is_flexible ? getters.date.flexible_date : 0,
                    begin: getters.date.starting_date_human,
                    end: getters.date.ending_date_human,
                    location_street: getters.location.street,
                    location_zip: getters.location.zip,
                    location_city: getters.location.city,
                    // clients_locally_contact_hash,
                    additional_info: getters.baseData.additional_info,
                    // freetext: getters.baseData.freetext,
                    articles: getters.current_articles,
                    // fav_user: getters.selected_user,
                    jobs_tasks_name: getters.location.city,
                    job_name: getters.baseData.order_name ? `${getters.baseData.order_name} ${getters.location.street}` : getters.location.street,
                    travel_costs: getters.totalTravelCost,
                    // first_offer: getters.baseData.first_offer,
                    parent_category: getters.selected_category,
                    first_offer: payload.first_offer || false,
                    quicksale: true,
                    verified: false
                }
                if (payload.jobs_hash) {
                    storeData.jobs_hash = payload.jobs_hash;
                }
                if (getters.baseData.clients_addresses_hash) {
                    storeData.clients_addresses_hash = getters.baseData.clients_addresses_hash;
                }

                if (getters.baseData.flexible_date_contacts_mail || getters.baseData.flexible_date_contacts_mobile) {
                    storeData.additional_info += `Kontakt zur Terminvereinbarung:
                    E-Mail: ${getters.baseData.flexible_date_contacts_mail}
                    Mobil: ${getters.baseData.flexible_date_contacts_mobile}`;
                }

                if (payload.verified) {
                    storeData.verified = true
                }
                const response = await OrdersService.saveOrder(storeData);
                commit('saveOrderSuccess', response);
                if (!payload.first_offer && getters.auth.newUser) {
                    this.dispatch('orders/resetCode');
                }
            } catch (e) {
                if (e instanceof FetchingError) {
                    commit('savingError', { errorCode: e.errorCode, errorMessage: e.message })
                }
                return false;
            }
    },
    async fetchFlexibleDateHints({commit}) {
        commit('fetchingRequest');
        try {
            const flexibleDateHints = await OrdersService.fetchFlexibleDateHints();
            commit('fetchFlexibleDateHintsSuccess', flexibleDateHints);
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }
            return false
        }
    },

    async fetchCountries({commit}) {
        commit('fetchingRequest');
        try {
            const countries = await OrdersService.fetchCountries();
            commit('fetchingCountriesSuccess', countries);
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }
            return false
        }
    },
    async fetchClient( { commit }, payload) {
        commit('fetchingRequest');
        try {
            const client = await OrdersService.fetchClient(payload);
            commit('fetchingClientSuccess', client);
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }
            return false
        }
    },
    async fetchCategory({ commit, getters } ) {
        commit('fetchingRequest');
        try {
            const options = {
                ...getters.location,
                category_id: getters.category.id,
                distance: getters.baseData.max_distance,
                photographers_min_rating: getters.baseData.photographers_min_rating,
            }
            const category = await OrdersService.fetchCategory(options);
            if (category.children.length > 0) {
                category.children.map((sub) => {
                    sub.sum = 0;
                    sub.sum_brutto = 0;
                    sub.hide_category_description = false;
                    sub.show_amount = false;
                    sub.articles_text = '';
                    sub.articles_attributes = '';
                    sub.articles_is_customizable = false;
                    sub.visible = false;
                    sub.readmore = false;
                    return sub;
                })
            }
            // TODO -> durch alle article durchgehen und user dazu finden (vergleiche mit fetch_labor_forces)
            commit('fetchingCategorySuccess', category);
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }
            return false
        }
    },
    async fetchPrices( { commit }, laborForces) {
        commit('fetchingPricesRequest');
        try {
            // if there are no users found, just commit the price
            if (!laborForces) {
                commit('fetchingPricesSuccess', []);
                return;
            }

            // if there are users found map the prices with the custom prices of the user
            const users = laborForces.map(user => {
                user.customized_articles = user.customized_articles.map(article => {
                    article.articles_selling_price = parseFloat(article.articles_selling_price);
                    return article;
                });
                return user;
            });
            commit('fetchingPricesSuccess', users);
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }
        }
    },
    async updateSubcategory({ commit }, options) {
        // commit('fetchingLaborsForcesRequest');
        commit('updateSubcategoryRequest');
        try {
            commit('updateSubcategory', options);
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }
            return false
        }
    },
    async addArticle({ commit }, payload) {
        // commit('fetchingLaborsForcesRequest');
        try {
            await this.dispatch('orders/resetTotals');
            commit('addArticle', payload );
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }
            return false
        }
    },
    async resetTotals( { commit } ) {
        commit('resetTotals');
    },
    async updateArticle({ commit }, payload) {
        // commit('fetchingLaborsForcesRequest');
        try {
            commit('updateArticle', payload );
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }
            return false
        }
    },
    async removeArticle( {commit}, payload) {
        commit('fetchingLaborsForcesRequest');
        try {
            commit('removeArticle', payload);
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }
            return false
        }
    },
    async removeArticles( { commit }, payload) {
        commit('removeArticlesRequest');
        try {
            commit('removeArticles', payload);
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }
            return false
        }
    },
    async setVerificationDigit( { commit }, payload) {
        try {
            commit('setVerificationDigit', payload);
        } catch (e) {
            if (e instanceof FetchingError) {
                commit('fetchingError', { errorCode: e.errorCode, errorMessage: e.message })
            }
            return false
        }
    }
}

const mutations = {
    setVerificationDigit(state, payload) {
        state.verificationCode += payload.digit;
    },
    updateCurrentStep(state, step) {
        state.hideNavigation = step >= 6;
        state.currentStep = step
    },
    updateCategoriesSelection(state, payload) {
        state.selected_category = payload.categories_id
    },
    clearFetching(state) {
        state.fetching = false;
        state.fetchingLaborsForces = false;
    },
    fetchingError(state, { errorCode, errorMessage }) {
        state.fetching = false;
        state.fetchingErrorCode = errorCode;
        state.fetchingError = errorMessage;
    },
    fetchingUserExistsSuccessFull(state) {
        state.fetching = false;
        state.userExists = true;
    },
    fetchingUserExistsError(state) {
        state.fetching = false;
        state.userExists = false;
    },
    savingError(state, payload) {
        state.fetching = false;
        state.fetchingError = payload.errorCode;
        state.fetchingError = payload.errorMessage;
    },
    saveOrderRequest(state) {
        state.savingOrder = true;
        state.fetchingError = '';
        state.fetchingErrorCode = 0;
    },
    saveOrderSuccess(state, payload) {
        state.job.jobs_hash = payload.jobs_hash || '';
        state.savingOrder = false;
        state.savingOrderSuccess = true;
        state.fetching = false;
    },

    getOrCreateClientRequest(state) {
        state.fetching = true;
        state.fetchingError = '';
        state.fetchingErrorCode = 0;
    },
    getOrCreateClientSuccess(state, payload) {
        const { 
            clients_hash, 
            clients_contacts_hash, 
            clients_addresses_hash,
            clients_contacts_firstname,
            clients_contacts_lastname
        } = payload;
        state.fetching = false;
        state.fetchingError = '';
        state.fetchingErrorCode = 0;
        state.baseData.clients_hash = clients_hash;
        state.baseData.clients_contacts_hash = clients_contacts_hash;
        state.baseData.clients_addresses_hash = clients_addresses_hash;
        state.baseData.clients_contacts_firstname = clients_contacts_firstname;
        state.baseData.clients_contacts_lastname = clients_contacts_lastname;
        state.codeSent = true;
    },
    getOrCreateClientError(state, { errorCode, errorMessage}) {
        state.fetching = false;
        state.fetchingError = errorMessage;
        state.fetchingErrorCode = errorCode;
    },


    fetchCategoryRequest(state) {
        state.fetching = true;
        state.fetchingError = '';
        state.fetchingErrorCode = 0;
    },
    fetchingRequest(state) {
        state.fetching = true;
        state.fetchingError = '';
        state.fetchingErrorCode = 0;
    },
    fetchingLaborsForcesRequest(state) {
        state.fetchingLaborsForces = true;
        state.fetchingError = '';
        state.fetchingErrorCode = 0;
    },
    fetchingPricesRequest(state) {
        state.fetching = true;
        state.fetchingError = '';
        state.fetchingErrorCode = 0;
    },
    removeArticlesRequest(state) {
        state.fetching = true;
        state.fetchingError = '';
        state.fetchingErrorCode = 0;
    },
    updateSubcategoryRequest(state) {
        state.fetchingLaborsForces = true;
        state.fetching = true;
        state.fetchingError = '';
        state.fetchingErrorCode = 0;
    },
    addArticle(state, payload) {
        const { articles_hash, sub_category_key } = payload;
        if (!articles_hash) {
            state.subCategories[sub_category_key].current_article = '';

            const current_articles = state.subCategories.filter(
                sub => {
                    return sub.current_article;
                }
            );
            const res = current_articles.map(
                article => {
                    return article.current_article;
                }
            );
            state.current_articles = res;
        }
        const article = {
            key_art_cat: `${articles_hash}-${sub_category_key}`,
            ...payload
        };
        state.articles.push(article);
        const current_article = state.subCategories[sub_category_key].articles.filter(a => a.articles_hash == articles_hash);
        state.subCategories[sub_category_key].current_article = current_article[0];
        // state.subCategories[sub_category_key].show_amount = article.articles_is_amountable_by_client ?? false;

        const current_articles = state.subCategories.filter(
            sub => {
                return sub.current_article;
            }
        );
        const res = current_articles.map(
            article => {
                return article.current_article;
            }
        );
        state.current_articles = res;

        state.current_articles.forEach(
            article => {
                state.totals.netto += article.articles_selling_price;
                state.totals.brutto += article.articles_selling_price + article.articles_vat_absolute
                state.totals.vat_sum += article.articles_vat_absolute
                state.totalTravelCost += article.avg_travel_cost
                state.totals.vat[article.articles_vat_percent].sum += article.articles_vat_absolute
            }
        );

        state.footerExpanded = state.current_articles.length > 0;

        state.fetchingLaborsForces = false;
    },
    updateArticle(state, payload) {
        const { 
            articles_hash, 
            articles_amount,
            articles_selling_price
        } = payload;
        const articles = state.articles.map(article => {
            return article.articles_hash;
        });
        const index = articles.indexOf(articles_hash);
        state.articles[index] = {
            ...state.articles[index],
            articles_selling_price: articles_selling_price,
            articles_amount: articles_amount
        }
        state.fetchingLaborsForces = false;
    },
    removeArticles(state, { articles_hashes, sub_category_key }) {
        state.fetching = false;

        articles_hashes.forEach(hash => {
            state.articles = state.articles.filter(
                article => {
                    return article.articles_hash != hash && article.sub_category_key != sub_category_key;
                }
            )
        })
    },
    removeArticle(state, { articles_hash }) {
        state.fetchingLaborsForces = false;
        if (state.articles.find(article => article.articles_hash === articles_hash)) {
            state.articles = state.articles.filter(article => article.articles_hash !== articles_hash);
        }
    },
    storeBaseData(state, payload) {
        state.fetching = false;
        // state.baseData = baseData;
        const baseData = state.baseData;
        state.baseData = { ...baseData, ...payload }
    },
    fetchingClientSuccess(state, payload) {
        state.fetching = false;
        state.baseData.clients_show_freetext = payload.clients_show_freetext;
    },
    fetchingCategorySuccess(state, category) {
        state.fetching = false;
        const children = category.children.filter(sub => {
            const articles = sub.articles.filter(article => article.articles_name_short != "");
            // if (articles.length == 0) {
            //     console.log(sub);
            // }
            return articles.length > 0;
            // return true;
        })
        state.subCategories = children.length == 0 ? [] : children;
        state.categoryTitle = category.jobs_tasks_categories_name;
        state.categoryIsCollection = category.jobs_tasks_categories_collection;
        // state.subCategories = cat.children.length == 0 ? [] : cat.children;
        // state.categoryTitle = cat.jobs_tasks_categories_name;
        // state.categoryIsCollection = cat.jobs_tasks_categories_collection;
    },
    fetchingPricesSuccess(state, payload) {
        state.static_articles = state.articles.filter(article => article.articles_is_customizable == 0);
        state.customizable_articles = state.articles.filter(article => article.articles_is_customizable == 1);

        // get selected articles
        const articles = state.articles.map(article => {
            // const arr = article.split("-");
            // return `${arr[0]}-${arr[1]}`
            return article.articles_hash;
        });

        // search for selected articles in users custom prices
        const users = payload
            .filter(user => user.customized_articles.length > 0);
        const customized_articles = []
        users.forEach(user => {
            user.customized_articles.forEach(custom_article => {
                if (articles.indexOf(custom_article.articles_hash) >= 0) {
                    const articles_hash = custom_article.articles_hash;
                    
                    if (!customized_articles[articles_hash]) {
                        customized_articles[articles_hash] = [];
                    }
                    customized_articles[custom_article.articles_hash].push(custom_article.articles_selling_price);
                }
            })
        });
        
        state.subCategories.map(sub => {
            sub.articles.map(article => {
                if (customized_articles.length == 0) {
                    article.articles_min_selling_price = article.articles_selling_price;
                    return article;
                }
                const customMinPrice = Math.min.apply(null, customized_articles[article.articles_hash]);
                if (customMinPrice > article.articles_selling_price) {
                    article.articles_min_selling_price = article.articles_selling_price;
                } else {
                    article.articles_min_selling_price = customMinPrice == "Infinity" ? article.articles_selling_price : customMinPrice;
                }
                return article;
            });

            const minPrice = sub.articles.filter(article => articles.indexOf(article.articles_hash) >= 0).map(article => parseFloat(article.articles_min_selling_price));
            sub.sum = minPrice.length == 0 ? sub.sum : minPrice[0];
            sub.hide_category_description = sub.sum > 0;
            return sub;
        });

        if (payload.length == 0) {
            state.totals = {
                sum: 0,
                sum_brutto: 0,
                vat: {
                    0: { sum: 0 },
                    7: { sum: 0 },
                    19: { sum: 0 }
                }
            };
            state.articles.forEach(article => {
                const article_vat = parseFloat(article.articles_vat_absolute);
                const article_sum = parseFloat(article.articles_selling_price);
                const article_sum_brutto = article_vat + article_sum;
                state.totals.sum += article_sum;
                state.totals.sum_brutto += article_sum_brutto;
                state.totals.vat[article.articles_vat_percent].sum += article_vat;
            });
        }

        state.fetching = false;
    },
    fetchingCountriesSuccess(state, countries) {
        state.fetching = false;
        state.countries = countries;
        state.location.country = state.baseData.country
    },
    fetchingCategoriesSuccess(state, categories) {
        state.fetching = false;
        state.categories = categories;
    },
    fetchFlexibleDateHintsSuccess(state, flexibleDateHints) {
        state.fetching = false;
        state.baseData.flexibleDateHints = flexibleDateHints;
    },
    generatePdfRequest(state) {
        state.fetching = true;
        state.fetchingError = '';
        state.fetchingErrorCode = 0;
    },
    generatePdfError(state, { errorCode, errorMessage }) {
        state.fetching = false;
        state.fetchingErrorCode = errorCode;
        state.fetchingError = errorMessage;
    },
    generatePdfSuccess(state, url) {
        state.fetching = false;        
        state.job.pdf_url = url;
    },
    fetcArticlesSuccess(state, payload) {
        state.fetching = false;
        state.articles = payload;
    },
    updateSubcategory(state, payload) {
        const sub_category_key = payload.key;
        const subCategory = state.subCategories[sub_category_key];
        delete payload.key;
        const subCategoryUpdated = { ...subCategory, ...payload }
        Vue.set(state.subCategories, sub_category_key, subCategoryUpdated)
        
        if (state.articles.length == 0) {
            state.laborForces = [];
        }
        state.fetchingLaborsForces = false;
        state.fetching = false;
        state.inputsChanged = true;
    },
    updateLocation(state, payload) {
        const location = state.location;
        state.location = { ...location, ...payload }
    },

    updateInvoiceAddress(state, payload) {
        const address = state.invoiceAddress;
        state.invoiceAddress = { ...address, ...payload};
    },
    updateDate(state, payload) {
        const date = state.date;
        state.inputsChanged = state.fetchingLaborsForcesComplete;
        state.date = { ...date, ...payload }
        if (payload.info) {
            state.baseData.additional_info = `Terminvereinbarung mit ${payload.info}`
        } else {
            if (state.baseData.additional_info.indexOf('Terminvereinbarung mit') == 0) {
                state.baseData.additional_info = '';
            }
        }

        // const currentDate = new Date().toJSON();
        // const date = currentDate.slice(0, 10);
        // const time = currentDate.slice(11, 16);

        const dateArray = state.date.starting_date.split('-');
        // state.date.starting_date = date;
        state.date.starting_date_human = `${dateArray[2]}.${dateArray[1]}.${dateArray[0]} ${state.date.starting_time}`;

        if (state.date.ending_date) {
            const endDateArray = state.date.ending_date.split('-');
            state.date.ending_date_human = `${endDateArray[2]}.${endDateArray[1]}.${endDateArray[0]} ${state.date.ending_time}`;
        }
    },

    // set /unset given user
    chooseUser(state, payload) {
        const { user_key } = payload;
        const user = state.laborForces[user_key];

        // reset travel costs if (another) user is choosen
        state.travel_costs = 0;
        state.travel_costs_brutto = 0;
        if (state.selected_user != user.user_hash) {
            state.articles.map(article => {
                const user_article = user.articles.filter(user_article => user_article.articles_hash == article.articles_hash);
                article.selected_user_price = 0;
                article.selected_user_price_brutto = 0;
                if (user_article) {
                    const selling_price = parseFloat(user_article[0].articles_selling_price);
                    const selling_price_vat = parseFloat(user_article[0].articles_vat_absolute);
                    article.selected_user_price = selling_price;
                    article.selected_user_price_brutto = selling_price + selling_price_vat;
                }
                return article;
            });
            if (user.travel_costs > 0) {
                state.travel_costs = user.travel_costs;
                state.travel_costs_brutto = user.travel_costs * 1.19;
            }
            state.totals = {
                sum: user.user_sum,
                sum_brutto: user.user_sum + user.user_sum_vat,
                vat: user.vat
            }
            state.selected_user = user.user_hash;
            state.hideSummary = false;
        } else {
            state.hideSummary = false;
            state.selected_user = '';
        }
    },
    resetUserSelection(state) {
        state.hideSummary = true;
        state.selected_user = '';
    },
    toggleArticleDescription(state, payload) {
        
        const { sub_category_key } = payload;
        const subCategory = state.subCategories[sub_category_key];
        state.subCategories[sub_category_key].visible = !subCategory.visible;
        
    },
    toggleArticlesVisibilty(state, payload) {
        const { sub_category_key } = payload;
        if (state.subCategories[sub_category_key]) {
            state.subCategories[sub_category_key].visible = !state.subCategories[sub_category_key].visible;
        }
    },
    subcategoryReadmore(state, payload) {
        const { sub_category_key } = payload;
        const readmore = state.subCategories[sub_category_key].readmore || false;
        if (state.subCategories[sub_category_key]) {
            state.subCategories[sub_category_key].readmore = !readmore;
        }
    },
    setCurrentDatetime(state) {
        const currentDate = new Date().toJSON();
        const date = currentDate.slice(0, 10); 
        const time = currentDate.slice(11,16);

        const dateArray = date.split('-');

        state.date.starting_date = date;
        state.date.starting_date_human = `${dateArray[2]}.${dateArray[1]}.${dateArray[0]} ${time}`;
        state.date.starting_time = time;
    },
    fetchingVerificationRequest(state) {
        state.fetchingVerification = true
        state.fetchingVerificationError = '';
        state.fetchingVerificationSuccess = false;
    },
    fetchingVerificationSuccess(state) {
        state.fetchingVerification = false
        state.fetchingVerificationError = '';
        state.fetchingVerificationSuccess = true;
    },
    fetchingVerificationError(state) {
        state.fetchingVerification = false
        state.fetchingVerificationError = 'Code ungültig';
        state.fetchingVerificationSuccess = false;
    },
    sendingCode(state) {
        state.sendingCode = true;
        state.codeSent = false;
        state.verificationCode = '';
        state.fetchingVerificationSuccess = false;
        state.fetchingVerificationError = false;
    },
    codeSent(state, payload) {
        state.sendingCode = false;
        state.codeSent = true;
        state.codeSentText = payload.text;
    },
    resetTotals(state) {
        state.totals = {
            brutto: 0,
            netto: 0,
            vat_sum: 0,
            vat: {
                0: { sum: 0 },
                7: { sum: 0 },
                19: { sum: 0 }
            }
        };
        state.totalTravelCost = 0;
    },
    toggleFooterHiddenState(state) {
        state.footerExpanded = !state.footerExpanded;
    },
    resetFetching(state) {
        state.fetching = false;
        state.errorCode = 0;
        state.errorMessage = '';
    },
    updatePassword(state, payload) {
        state.password = payload.password
    },
    signInRequest(state) {
        state.auth.authenticating = true;
        state.auth.authenticated = false;
        state.auth.authenticatingError = false;
        state.auth.newUser = true;
    },
    signInSuccessfull(state, payload) {
        state.auth.authenticating = false;
        state.auth.authenticated = true;
        state.auth.authenticatingError = false;
        state.auth.newUser = false;
        if (payload && payload.newUser == true) {
            state.auth.newUser = true;
        }
    },
    signInFailed(state) {
        state.auth.authenticating = false;
        state.auth.authenticated = false;
        state.auth.authenticatingError = true;
        state.auth.newUser = true;
    },
    signInReset(state) {
        state.auth.authenticating = false;
        state.auth.authenticated = false;
        state.auth.authenticatingError = false;
        state.auth.newUser = true;
    },

    resetPwRequest(state) {
        state.pwResetting = true;
        state.pwResetted = false;
        state.pwResettedText = 'Kennwort wird zurückgesetzt...'
    },
    resetPwSuccessfull(state, payload) {
        state.pwResetting = false;
        state.pwResetted = true;
        state.pwResettedText = payload.text
    },
    resetPwReset(state) {
        state.pwResetting = false;
        state.pwResetted = false;
        state.pwResettedText = '';
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}